import { render, staticRenderFns } from "./receivingKindBox.vue?vue&type=template&id=093ab0a6&"
import script from "./receivingKindBox.vue?vue&type=script&lang=js&"
export * from "./receivingKindBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports